<template>
  <div >
    <h3 class="title">Reference</h3>
    <ol>
      <li id="ref">
        Matzke, GR, McGory, RW, Halstenson, CE. Pharmacokinetics of vancomycin in patients with various degrees of renal function. Antimicrob Agents Chemother. 1984;25(4):433–437. doi:
        <a
          href="https://doi.org/10.1128/aac.25.4.433"
        >10.1128/aac.25.4.433</a>
      </li>
      <li id="ref">
        Crass RL, Dunn R, Hong J, Krop LC, Pai MP. Dosing vancomycin in the super obese: less is more. J Antimicrob Chemother. 2018;73(11):3081-3086. doi:
        <a
          href="https://doi.org/10.1093/jac/dky310"
        >10.1093/jac/dky310</a>
      </li>
      <li id="ref">
        SHC Vancomycin Dosing Guide [Internet]. Stanford Antimicrobial Safety & Sustainability Program [cited 2020 Jul 6];Available from:
        <a
          href="http://med.stanford.edu/bugsanddrugs/guidebook.html"
        > http://med.stanford.edu/bugsanddrugs/guidebook.html</a>
      </li>
      <li id="ref"> 
        <a href="http://sites.utexas.edu/pharmacotherapy-rounds/files/2018/03/BadwalRR_FinalHandout-without-pic-March-2018.pdf">Vanquish Thy Troughs: Targeting AUC/MIC for Vancomycin Dosing</a></li>
      <li>
        Bauer LA. The Aminoglycoside Antibiotics. In: Bauer LA. eds. Applied Clinical Pharmacokinetics. 3rd Ed. New York, NY: 2014.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "ref"
};
</script>

<style scope >
.div#li {
  margin-right: 2px;
  margin-left: 2px;
  list-style-type: decimal;
}
</style>